const apiUrl = process.env.REACT_APP_API_URL

export default function getClassListDownloadUrl() {
    return `${apiUrl}/static/blank-class-list.csv`
}
